import MainHeader from '../components/layouts/mainHeader';
import React, { useContext, useEffect } from 'react';
import Layout from '../layouts/common';
import { Box, Container, Divider, Heading, Link, Text } from '@chakra-ui/react';
import ProjectCreateForm from '../components/projects/projectCreateForm';
import NextLink from 'next/link';
import { useAuth } from '../providers/AuthProvider';

export default function Custom404() {
  const { currentUser } = useAuth();

  useEffect(() => {
    if (!currentUser && process.env.NEXT_PUBLIC_ENVIRONMENT === 'production') {
      location.href = 'https://lp.ai-copywriter.jp/';
    }
  });

  return (
    <>
      <Layout>
        <MainHeader title={'お探しのページは存在しません'} />
        <Container w={'100%'} bg={'white'} p={12}>
          <Text>URLをご確認の上、再度アクセスしていただきますようお願いいたします。</Text>
          <Text>
            なお、不具合であると思われる場合は、
            <Link
              href={'https://forms.gle/oZTrxU5i32bHydRZ8'}
              target={'_blank'}
              color={'blue.600'}
              textDecoration={'underline'}
            >
              お問い合わせ(Google Formが開きます)
            </Link>
            をいただけますと幸いです。
          </Text>

          <Box mt={12}>
            <NextLink href={'/dashboard'} passHref>
              <Link color={'blue.600'}>ダッシュボードへ</Link>
            </NextLink>
          </Box>
        </Container>
      </Layout>
    </>
  );
}
